<template>
  <v-container fluid class="mt-3 docForm">
    <v-row>
      <v-col cols="12">
        <v-toolbar color="secondary" flat dense>
          <v-toolbar-title>Record Production</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" small text to="/production-records">
            <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
          </v-btn>
        </v-toolbar>
      </v-col>
    </v-row>

    <v-card class="mt-2">
      <v-row>
        <v-col cols="12" md="6">
          <v-autocomplete style="width: 500px" autocomplete="off" v-model="selectedTemplate"
            :items="productionTemplates" item-text="product.Name" item-value="id" cache-items class="mt-2" flat
            hide-no-data hide-details label="Select Product Template" outlined dense
            @change="getTemplateRawMaterials(selectedTemplate)"></v-autocomplete>
        </v-col>
        <v-col cols="12" md="3" offset-md="3">
          <div class="pr-2">
            <DatePicker class="px-2" @date="setDate" :myDate="date" :title="`Date`" ref="dateRef"></DatePicker>
          </div>
        </v-col>
      </v-row>
    </v-card>

    <v-row class="mt-2">

      <v-col cols="12" md="6">
        <v-card>
          <v-toolbar color="secondary" flat dense>
            <v-toolbar-title>Product Produced</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-row>

              <v-col cols="12">
                <div class="style-24" style="padding: 20px; color: orange">
                  <span>{{ producedItemName }}</span>
                </div>
              </v-col>

              <v-col cols="6" md="6">
                <div>
                  <v-text-field name="producedQty" outlined dense label="Qty Produced (Pcs)" v-model="producedQty"
                    type="number" autocomplete="off" class="px-2"></v-text-field>
                </div>
              </v-col>

              <v-col cols="6" md="6">
                <v-btn color="primary" class="float-right" :loading="loader" :disabled="loader" @click="save">
                  <v-icon left>mdi-content-save</v-icon>Save Production
                </v-btn>
              </v-col>

            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card>
          <v-toolbar color="secondary" flat dense>
            <v-toolbar-title>Raw Materials Used</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-row class="subtitle-2 text--primary">
              <v-col cols="12">
                <span v-if="parseFloat(producedQty) > 0" style="font-weight: bold; font-size: 16px">Production Cost: {{
                  (totalRawMaterials * parseFloat(producedQty)) | currency }}</span>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <!-- start of table -->
                <v-data-table :items-per-page="pageItems" :headers="headers" :items="rawMaterials"
                  :mobile-breakpoint="zeroValue" hide-default-footer disable-sort>
                  <template v-slot:item.Name="{ item }">
                    <v-text-field style="width: 250px" class="orderInput" single-line dense readonly
                      v-model="item.Name"></v-text-field>
                  </template>

                  <template v-slot:item.Factor>
                    <span>{{ producedQty }}</span>
                  </template>

                   <template v-slot:item.LineTotal="{ item }">
                    <span>{{ item.LineTotal * parseFloat(producedQty) }}</span>
                  </template>

                </v-data-table>
                <!-- end -->
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

    </v-row>

    <snackbar ref="snackbar"></snackbar>

    <v-divider></v-divider>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    zeroValue: 0,
    title: "",
    search: "",
    producedQty: null,
    producedItemId: null,
    producedItemName: null,
    date: new Date().toISOString().substr(0, 10),
    selectedTemplate: null,
    selectedProduct: "",
    isLoading: false,
    productionTemplates: [],
    products: [],
    rawMaterialProducts: [],
    rawMaterials: [],
    producedGoods: [],
    searchProducts: null,
    searchRawMaterials: null,
    select: null,
    pageItems: 100,
    headers: [
      { text: "Name", value: "product.Name" },
      { text: "Quantity", value: "Quantity" },
      { text: "Unit", value: "UOM.UomName" },
      { text: "Cost", value: "Price" },
      { text: "M. Factor", value: "Factor" },
      { text: "Total", value: "LineTotal" },
      // { text: "Action", value: "action", sortable: false }
    ],
    producedGoodsHeaders: [
      { text: "Name", value: "Name" },
      { text: "Quantity", value: "Quantity" },
      { text: "Unit", value: "UomEntry" },
      { text: "Cost", value: "Price" },
      { text: "Total", value: "DisplayTotal" },
      { text: "Action", value: "action", sortable: false }
    ],
    customers: [],
    customersDialog: false,
    excelFile: null,
    loader: false
  }),
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
    totalRawMaterials() {
      let total = 0;
      if (
        typeof this.rawMaterials != "undefined" &&
        this.rawMaterials.length > 0
      ) {
        return this.rawMaterials
          .map(item => {
            const amount = item.LineTotal;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    totalProducedGoods() {
      let total = 0;
      if (
        typeof this.producedGoods != "undefined" &&
        this.producedGoods.length > 0
      ) {
        return this.producedGoods
          .map(item => {
            const amount = item.LineTotal;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    }
  },
  watch: {
    searchRawMaterials(val) {
      if (val && val !== this.select && this.queryRawMaterials(val)) {
        this.queryRawMaterials(val);
      }
    },
    searchProducts(val) {
      if (val && val !== this.select && this.querySelections(val)) {
        this.querySelections(val);
      }
    }
  },
  methods: {
    setDate(date) {
      this.date = date;
    },
    save() {
      if (this.rawMaterials.length == 0) {
        this.$refs.snackbar.show("Please add raw materials", "red");
        return;
      }

      if (this.producedQty == null || this.producedQty == undefined || this.producedQty == "") {
        this.$refs.snackbar.show("Please fill in the produced qty ! ", "red");
        return;
      }

      var rawMaterialsData = [];
      for (const record of this.rawMaterials) {
        var details = {
          ProductId: record.rawMaterialId,
          UomEntry: record.UomEntry,
          Quantity: parseFloat(record.Quantity) * parseFloat(this.producedQty),
          Price: parseFloat(record.Price),
          LineTotal: parseFloat(record.LineTotal) * parseFloat(this.producedQty)
        };

        rawMaterialsData.push(details);
      }

      var data = {
        title: this.title,
        date: this.date,
        producedItemId: parseInt(this.producedItemId),
        producedQty: parseFloat(this.producedQty),
        rawMaterials: rawMaterialsData,
      };


      const url = "/create-production";
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.$router.push("/production-records");
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        }).finally(() => {
          self.loader = false;
        });
    },
    deleteRawMaterialRow(item) {
      const selectedRow = this.rawMaterials.find(record => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.rawMaterials.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.rawMaterials.splice(pos, 1);
    },
    deleteProductionRow(item) {
      const selectedRow = this.producedGoods.find(record => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.producedGoods.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.producedGoods.splice(pos, 1);
    },
    rawMaterialUomChange(item, ugp1) {
      const currentItem = this.rawMaterials.find(record => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.rawMaterials.indexOf(currentItem);
      if (pos === -1) {
        return;
      }

      const ugp1Record = ugp1.find(record => {
        return record.UomEntry === item.UomEntry;
      });

      currentItem.Price = ugp1Record.BuyingPrice;
      this.rawMaterials[pos] = currentItem;
      this.qtyChangedRawMaterial(currentItem);
    },
    productionUomChange(item, ugp1) {
      const currentItem = this.producedGoods.find(record => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.producedGoods.indexOf(currentItem);
      if (pos === -1) {
        return;
      }

      const ugp1Record = ugp1.find(record => {
        return record.UomEntry === item.UomEntry;
      });

      currentItem.Price = ugp1Record.BuyingPrice;
      this.producedGoods[pos] = currentItem;
      this.qtyChangedProduction(currentItem);
    },
    qtyChangedRawMaterial(data) {
      let Price;
      let Quantity;
      if (data.Price) {
        Price = parseFloat(data.Price);
      } else {
        Price = 0;
      }
      if (data.Quantity) {
        Quantity = parseFloat(data.Quantity);
      } else {
        Quantity = 0;
      }

      const TotalCost = Price * Quantity;
      const LineTotal = Math.round(TotalCost);
      const DisplayTotal = LineTotal.toLocaleString();
      // find item
      const currentItem = this.rawMaterials.find(record => {
        return record.LineNum === data.LineNum;
      });
      const pos = this.rawMaterials.indexOf(currentItem);
      if (pos === -1) {
        return;
      }
      // end of find

      currentItem.LineTotal = LineTotal;
      currentItem.DisplayTotal = DisplayTotal;
      this.rawMaterials[pos] = currentItem;
    },
    qtyChangedProduction(data) {
      let Price;
      let Quantity;
      if (data.Price) {
        Price = parseFloat(data.Price);
      } else {
        Price = 0;
      }
      if (data.Quantity) {
        Quantity = parseFloat(data.Quantity);
      } else {
        Quantity = 0;
      }

      const TotalCost = Price * Quantity;
      const LineTotal = Math.round(TotalCost);
      const DisplayTotal = LineTotal.toLocaleString();
      // find item
      const currentItem = this.producedGoods.find(record => {
        return record.LineNum === data.LineNum;
      });
      const pos = this.producedGoods.indexOf(currentItem);
      if (pos === -1) {
        return;
      }
      // end of find

      currentItem.LineTotal = LineTotal;
      currentItem.DisplayTotal = DisplayTotal;
      this.producedGoods[pos] = currentItem;
    },
    setRawMaterialItem(id) {
      const store_id = this.activeStore;
      const self = this;
      var customerId = 0;

      var data = {
        CustomerId: parseInt(customerId),
        ProductId: parseInt(id)
      };

      var url = `/product-prices`;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          console.log(res, " raw material res ");
          if (res.ResultCode == 1200) {
            const product = res.ResponseData;

            // current item definition
            let currentItem = {};
            currentItem.Quantity = 1;
            currentItem.ManualStatus = product.HasUom == 0 ? "Y" : "N";
            currentItem.UomEntry = product.IUoMEntry;
            currentItem.o_i_t_m_s_id = id;
            currentItem.Name = product.Name;
            currentItem.store_id = store_id;
            const LineNum = new Date().getTime();
            currentItem.LineNum = LineNum;
            currentItem.DiscSum = null;
            // end

            let initArray = [];
            if (product.HasUom === 0) {
              // check if manual yes and assign
              var sellingPrice = product.sellingPrice;
              var buyingPrice = product.buyingPrice;
              currentItem.BuyingPrice = buyingPrice;
              currentItem.Price = sellingPrice;
              currentItem.currentPrice = sellingPrice;
              currentItem.UomEntry = 0;
              const total = 1 * parseFloat(sellingPrice);
              currentItem.LineTotal = total;
              currentItem.DisplayTotal = total.toLocaleString();

              initArray.push(currentItem);
              this.rawMaterials = [...this.rawMaterials, ...initArray];
              this.selectedRawMaterial = "";
              // end of manual yes
            }

            // start of manual No status
            if (product.HasUom === 1) {
              let ugp1Data = product.ugp1;
              const ugp1Record = ugp1Data.find(record => {
                return record.UomEntry === product.IUoMEntry;
              });
              currentItem.ugp1 = product.ugp1;
              currentItem.Price = ugp1Record.SellingPrice;
              currentItem.BuyingPrice = ugp1Record.BuyingPrice;
              currentItem.currentPrice = ugp1Record.SellingPrice;
              const total = 1 * ugp1Record.SellingPrice;
              currentItem.LineTotal = total;
              currentItem.DisplayTotal = total.toLocaleString();

              // push to array
              initArray.push(currentItem);
              this.rawMaterials = [...this.rawMaterials, ...initArray];
              this.selectedRawMaterial = "";
              self.rawMaterialProducts = [];
              // end of push
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    setProductionItem(id) {
      const store_id = this.activeStore;
      const self = this;
      var customerId = 0;

      var data = {
        CustomerId: parseInt(customerId),
        ProductId: parseInt(id)
      };

      var url = `/product-prices`;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            const product = res.ResponseData;

            // current item definition
            let currentItem = {};
            currentItem.Quantity = 1;
            currentItem.ManualStatus = product.HasUom == 0 ? "Y" : "N";
            currentItem.UomEntry = product.IUoMEntry;
            currentItem.o_i_t_m_s_id = id;
            currentItem.Name = product.Name;
            currentItem.store_id = store_id;
            const LineNum = new Date().getTime();
            currentItem.LineNum = LineNum;
            currentItem.DiscSum = null;
            // end

            let initArray = [];
            if (product.HasUom === 0) {
              // check if manual yes and assign
              var sellingPrice = product.sellingPrice;
              var buyingPrice = product.buyingPrice;
              currentItem.BuyingPrice = buyingPrice;
              currentItem.Price = sellingPrice;
              currentItem.UomEntry = 0;
              currentItem.currentPrice = sellingPrice;
              const total = 1 * parseFloat(sellingPrice);
              currentItem.LineTotal = total;
              currentItem.DisplayTotal = total.toLocaleString();

              initArray.push(currentItem);
              this.producedGoods = [...this.producedGoods, ...initArray];
              this.selectedProduct = "";
              // end of manual yes
            }

            // start of manual No status
            if (product.HasUom === 1) {
              let ugp1Data = product.ugp1;
              const ugp1Record = ugp1Data.find(record => {
                return record.UomEntry === product.IUoMEntry;
              });
              currentItem.ugp1 = product.ugp1;
              currentItem.Price = ugp1Record.SellingPrice;
              currentItem.BuyingPrice = ugp1Record.BuyingPrice;
              currentItem.currentPrice = ugp1Record.SellingPrice;
              const total = 1 * ugp1Record.SellingPrice;
              currentItem.LineTotal = total;
              currentItem.DisplayTotal = total.toLocaleString();

              // push to array
              initArray.push(currentItem);
              this.producedGoods = [...this.producedGoods, ...initArray];
              this.selectedProduct = "";
              self.rawMaterialProducts = [];
              // end of push
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    querySelections(searchText) {
      const self = this;
      const url = "/products/search";

      var customerId = 0;

      const data = {
        SearchText: searchText,
        CustomerId: customerId
      };

      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.products = res.ResponseData;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    getTemplates() {
      const self = this;
      this.$store
        .dispatch("get", `/production-template`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.productionTemplates = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getTemplateRawMaterials(id) {
      // set produced item data 
      var producedItemRecord = this.productionTemplates.find((record) => {
        return record.id === id;
      });
      this.producedItemId = producedItemRecord.product.id;
      this.producedItemName = producedItemRecord.product.Name;

      // end of produced item data
      const self = this;
      this.$store
      this.$store
        .dispatch("get", `/production-template/${id}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.rawMaterials = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getTemplates();
  }
};
</script>
